<template>
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button
        class="accordion-button"
        :class="{ collapsed: !isOpen }"
        type="button"
        @click="$emit('toggle')"
      >
        {{ title }}
      </button>
    </h2>
    <div
      class="accordion-collapse collapse"
      :class="{ show: isOpen }"
    >
      <div class="accordion-body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title: string
  isOpen: boolean
}>()

defineEmits<{
  (e: 'toggle'): void
}>()
</script>

<style scoped>
.accordion-item {
  width: 100%;
}

.accordion-collapse {
  transition: height 0.35s ease;
}

.accordion-button:focus {
  border: none;
  box-shadow: none;
}
</style>